import React from "react";

interface State {
    clock: string
}

class Clock extends React.Component<{}, State> {

    constructor(props:{}) {
        super(props);
        this.state = {
            clock: new Date().toLocaleString()
        };
    }

    componentDidMount() {
        setInterval( () => {
            this.setState({
            clock: new Date().toLocaleString(),
            })
        },1000)
    }

    render() {
        return (
            <label>{this.state.clock}</label>
        );
    }
}

export default Clock;
